const getStyles = () => {
  return {
    // Main Section
    section: {
      position: 'relative',
      overflow: 'hidden',
      padding: '100px 0',
      background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)'
    },

    container: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      '@media (min-width: 640px)': {
        padding: '0 24px'
      }
    },

    // Decorative Background Elements
    bgCircle1: {
      position: 'absolute',
      top: '80px',
      left: '60px',
      width: '280px',
      height: '280px',
      borderRadius: '50%',
      backgroundColor: 'rgba(139, 92, 246, 0.1)',
      filter: 'blur(60px)',
      animation: 'float 6s ease-in-out infinite alternate'
    },

    bgCircle2: {
      position: 'absolute',
      bottom: '120px',
      right: '100px',
      width: '380px',
      height: '380px',
      borderRadius: '50%',
      backgroundColor: 'rgba(236, 72, 153, 0.1)',
      filter: 'blur(80px)',
      animation: 'float 8s ease-in-out infinite alternate',
      animationDelay: '1s'
    },

    // Header
    header: {
      textAlign: 'center',
      marginBottom: '64px',
      animation: 'fadeIn 0.8s ease-out'
    },

    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: '#1a202c',
      marginBottom: '16px',
      '@media (min-width: 768px)': { fontSize: '3rem' }
    },

    subtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '600px',
      margin: '0 auto'
    },

    // Steps Grid
    grid: {
      position: 'relative',
      zIndex: 3
    },

    card: {
      position: 'relative',
      borderRadius: '20px',
      padding: '32px',
      textAlign: 'center',
      height: '100%',
      border: '1px solid #e5e7eb',
      backgroundColor: '#fff',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      animation: 'fadeIn 0.8s ease-out',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 30px rgba(0, 0, 0, 0.12)'
      }
    },

    iconWrapper: {
      position: 'relative',
      marginBottom: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    iconBox: {
      width: '80px',
      height: '80px',
      borderRadius: '20px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      boxShadow: '0 10px 25px rgba(139,92,246,0.3)'
    },

    stepNumber: {
      position: 'absolute',
      top: '-25px',
      right: 'calc(50% - 83px)',
      transform: 'translateX(80%)',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      backgroundColor: '#6366f1',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '1.2rem',
      boxShadow: '0 6px 20px rgba(99,102,241,0.4)'
    },

    stepTitle: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '12px',
      transition: 'color 0.3s ease',
      '&:hover': {
        color: '#a855f7'
      }
    },

    stepDescription: {
      color: '#6b7280',
      lineHeight: 1.7,
      fontSize: '1rem'
    },

    // Animations
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    },

    '@keyframes float': {
      '0%': { transform: 'translateY(0px)' },
      '100%': { transform: 'translateY(20px)' }
    }
  };
};

export default getStyles;
